import * as fullStory from 'js/lib/fullstory';
import user from 'js/lib/user';

import { isFreeTrialContract } from 'bundles/enterprise-admin-account/utils/AdminDashboardAccountUtils';

export const initializeFullStory = ({
  contracts,
  orgSlug,
}: {
  contracts: {
    contractType: string;
    contractTags?: { elements: { id: string; contractTag: string }[] };
  }[];
  orgSlug: string;
}) => {
  const isStandardContract = contracts.some((contract) => contract.contractType === 'STANDARD');
  const isFreeTrial = contracts.some((contract) => isFreeTrialContract(contract));

  const formattedSlugFullStory = orgSlug.toLowerCase().replace('_', '-');
  fullStory.start({ disableForCourserians: true });
  fullStory.set({
    pageType: 'EnterpriseAdminDashboard',
    slug: formattedSlugFullStory,
    isDirectSales: isStandardContract,
    isWES: !isStandardContract,
    isFreeTrial,
    externalId: user.get().external_id,
  });
};

export const terminateFullStory = () => {
  fullStory.stop();
};
